import React from 'react';
import { MainContainer } from 'components/shared';
import { AiUserInnerOptions } from '../AiUserInnerOptions';
import { SettingLayout } from 'layouts/SettingLayout';
import { useErrorHandler } from 'exceptions/ErrorHandler';
import { useAiUser } from 'hooks/api/settings/useAiUser';
import { useQuery } from 'react-query';
import { DataTable } from 'components/ui/DataTable';
import { useColumns } from './columns';
import { useFilterAiUsersStore } from 'store/settings/AiUser/filters';
import { usePaginationAiUsersStore } from 'store/settings/AiUser/pagination';
import { IAiUser } from 'interfaces/settings/AiUser/AiUser';
import { DeleteAiUser } from '../Delete';
import { DataFilter } from './DataFilter';

export const ListAiUsers: React.FC = () => {
  const { options } = AiUserInnerOptions();
  const { errorHandler } = useErrorHandler();
  const { getAiUsers } = useAiUser();
  const { filtersData } = useFilterAiUsersStore();
  const { pagination, setPagination } = usePaginationAiUsersStore();
  const [aiUserToDelete, setAiUserToDelete] = React.useState<IAiUser | null>(
    null
  );

  const handleDelete = (aiUser: IAiUser) => {
    setAiUserToDelete(aiUser);
  };

  const handleClearDelete = () => {
    setAiUserToDelete(null);
  };

  const { columns } = useColumns({ deleteAiUser: handleDelete });

  const { data, isLoading } = useQuery({
    queryKey: ['aiUsers', filtersData, pagination],
    queryFn: () => getAiUsers(filtersData, pagination),
    onError: errorHandler,
  });

  return (
    <MainContainer>
      <SettingLayout options={options} page="ai-users">
        <DataFilter />
        {aiUserToDelete && (
          <DeleteAiUser
            isOpen={!!aiUserToDelete}
            data={aiUserToDelete}
            onClose={handleClearDelete}
          />
        )}
        <section>
          <DataTable
            data={data?.aiUsers ?? []}
            isLoading={isLoading}
            columns={columns}
            manualPagination={true}
            pagination={data?.pagination ?? {}}
            onPaginationChange={setPagination}
            showControlColumns={false}
          />
        </section>
      </SettingLayout>
    </MainContainer>
  );
};
